// extracted by mini-css-extract-plugin
module.exports = {"container":"DeadlineList_container__C9xdA","header":"DeadlineList_header__2u2M5"};